// Mirrors the comparison range input into the --pos custom property that clips the before image.
class SBeforeAfter extends HTMLElement {
  #ac;

  connectedCallback() {
    this.#ac = new AbortController();
    const range = this.querySelector('[data-range]');
    if (!range) return;
    const update = () => this.style.setProperty('--pos', `${range.value}%`);
    range.addEventListener('input', update, { signal: this.#ac.signal });
    update();
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }
}

if (!customElements.get('s-before-after')) customElements.define('s-before-after', SBeforeAfter);
